/**
 * Created by claudio iozzia on 11/07/2017.
 */

import {IAppSpec} from "../../../../Redux/selector.state";
import {Ic} from "../../../../models/common";
import {NumLEDBounds} from "../../acdc/NumLEDBounds";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";
import {Range} from '../../../../common/Range';
import {tassign, Utils} from "../../../../common/utils";
import {IC_fsw} from "../../../../models/IC_fsw";
import {EMPTY_NOTE_LED, INoteLed, Validator_LED_Common} from "../../../../models/validator/validator_led_common";

export class Validator_DcLED_Buck extends Validator_LED_Common {

  protected validation(ic: Ic, spec: IAppSpec): INoteLed {
    const baseValidation = super.validation(ic, spec);
    const iDetails: INoteLed = tassign(EMPTY_NOTE_LED);
    const _specLedOut = spec.spec.value.output.outputs[0]; // the spec of led are in the first
    const _specLed = spec.spec.value.output.ledParam;

    const ubs: NumLEDBounds = NumLEDBounds.getIt(ic);

    const serieDomain: Range = new Range(1, ubs.series);
    const parallelDomain: Range = new Range(1, ubs.parallel);

    // Verifico se il LED, DA SOLO, è fuori range
    const vLoadRange: Range = this.getVoutBounds(ic, spec);
    const vfRange: Range = new Range(
      ValueFormatter.scale(vLoadRange.min / serieDomain.max, siPrefix.unit, 2, "c")
      , ValueFormatter.scale(vLoadRange.max / serieDomain.min, siPrefix.unit, 2, "f")
    );
    iDetails.VF = baseValidation.VF || Utils.acceptInRange(_specLedOut.voltage, vfRange.min, vfRange.max, "VF", "V", "should");

    const iLoadRange: Range = this.getIoutBounds(ic, spec);
    const ifRange: Range = this.getIFBounds(ic, parallelDomain, spec);
    iDetails.IF =  baseValidation.IF || Utils.acceptInRange(_specLedOut.current, ifRange.min, ifRange.max, "IF", "A", "should");


    // Se il LED, da solo, è compatibile con questa soluzione...
    // passiamo a validare il numero di led, serie e paralleli

    iDetails.Serial = Validator_LED_Common.validate_num(
      _specLed.serial,
      iDetails.VF !== null
        ? serieDomain
        : new Range(Math.ceil(vLoadRange.min / _specLedOut.voltage), Math.floor(vLoadRange.max / _specLedOut.voltage)),
      "number of led in series",
      serieDomain
    );


    iDetails.Parallel = Validator_LED_Common.validate_num(_specLed.parallel
      , iDetails.IF !== null
        ? parallelDomain
        : new Range(Math.ceil(iLoadRange.min / _specLedOut.current)
          , Math.floor(iLoadRange.max / _specLedOut.current))
      , "number of strings", parallelDomain);


    iDetails.Vout = Utils.acceptInRange(_specLedOut.voltage * _specLed.serial, vLoadRange.min, vLoadRange.max, "VLoad", "V", "should");
    iDetails.Iout = Utils.acceptInRange(_specLedOut.current * _specLed.parallel, iLoadRange.min, iLoadRange.max, "ILoad", "A", "should");

    // Rd not implemented
    // if( DlgUtils.isEmpty( iSpec.selectedLED.Rd ) )
    //   iDetails.Rd = EntityAlert.fromInfo("The Dynamic Resistance will be a required field in the design module");
    iDetails.Rd = baseValidation.Rd || { key : Utils.isNumberRequired(_specLed.rd, 'rd') };

    return iDetails;
  }

  protected getVoutBounds(ic: Ic, spec: IAppSpec): Range {
    const _vin = spec.spec.value.input;
    const _vin_note = spec.spec.note.input;
    // const dMax = Math.min(new IC_fsw(ic).dMax, 0.98);    //see code AS3 (LED_Buck_SpecFormValidator)
    const dMax = new IC_fsw(ic).dMax;

    let vOutUpperBound: number;

    const isAttendibileVinMin: boolean = !_vin_note.min.hasError && Utils.isValueReal(_vin.min);
    const isAttendibileVinMax: boolean = !_vin_note.max.hasError && Utils.isValueReal(_vin.max);

    // Se non ho errore su VinMin e VinMin non è vuoto...
    if (isAttendibileVinMin) {
      vOutUpperBound = _vin.min * dMax;
    } else if (isAttendibileVinMax) {
      // Se non ho errore su VinMax e VinMax non è vuoto...
      vOutUpperBound = _vin.max * dMax;
    } else {
      // altrimenti è quanto dichiarato nel dispositivo
      vOutUpperBound = ic.vout_max;
    }

    if (ic.vout_max < vOutUpperBound) {
      vOutUpperBound = ic.vout_max;
    }

    vOutUpperBound = ValueFormatter.scale(vOutUpperBound, siPrefix.unit, 1, "f");
    return new Range(ic.vout_min, vOutUpperBound);
  }

  protected hasCustomIFBounds(ic: Ic): boolean {
    return Utils.getFieldValue(ic, "validator.led.iRow") !== null;
  }

  protected getCustomIFBounds(ic: Ic): Range {
    const iRow: number = Utils.getFieldValue(ic, "validator.led.iRow", ic.iout_max);

    return new Range(Number.NEGATIVE_INFINITY, iRow);
  }

  protected getIoutBounds(ic: Ic, spec: IAppSpec): Range {
    return new Range(Number.NEGATIVE_INFINITY, ic.iout_max);
  }

  protected getIFBounds(ic: Ic, parallelDomain: Range, spec: IAppSpec): Range {
    if (this.hasCustomIFBounds(ic)) {
      return this.getCustomIFBounds(ic);
    } else {
      const iLoadRange: Range = this.getIoutBounds(ic, spec);
      return new Range(
        ValueFormatter.scale(iLoadRange.min / parallelDomain.max, siPrefix.unit, 2, "c"),
        ValueFormatter.scale(iLoadRange.max / parallelDomain.min, siPrefix.unit, 2, "f")
      );
    }
  }
}
